/** @format */

import { toast } from "react-toastify";

export function createBookMark(name, image, id) {
  //saving  name , id and image in local storage as array
  let bookmarks = [];

  if (localStorage.getItem("bookmarks") === null) {
    bookmarks.push({
      name,
      image,
      id,
    });
    localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
    toast("Bookmark added");
  } else {
    bookmarks = JSON.parse(localStorage.getItem("bookmarks"));
    //if a bookmark already exist returning an error. else adding the bookmark
    if (bookmarks.find((bookmark) => bookmark.id === id)) {
      toast.error("Bookmark already exist");
    } else {
      bookmarks.push({
        name,
        image,
        id,
      });
      localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
      toast("Bookmark added");
    }
  }

  return;
}

//function to delete an entry from bookmarks array
export function deleteBookMark(id) {
  let bookmarks = JSON.parse(localStorage.getItem("bookmarks"));
  bookmarks.forEach((bookmark, index) => {
    if (bookmark.id === id) {
      bookmarks.splice(index, 1);
    }
  });
  localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
  toast("Bookmark removed");
  return;
}

//returning the bookmarks array
export function getBookMarks() {
  let bookmarks = JSON.parse(localStorage.getItem("bookmarks"));
  //returning an empty array if bookmarks is null
  if (bookmarks === null) {
    return [];
  }
  return bookmarks;
}

//function to check if the given id is in the bookmarks array
export function checkBookMark(id) {
  let bookmarks = JSON.parse(localStorage.getItem("bookmarks"));
  if (bookmarks && bookmarks.find((bookmark) => bookmark.id === id)) {
    return true;
  } else {
    return false;
  }
}
